var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Draggable } from 'react-beautiful-dnd';
function Item(props) {
    var item = props.item, index = props.index, editMode = props.editMode;
    if (editMode) {
        return (
        // @ts-ignore
        _jsx(Draggable, __assign({ style: { top: "auto", left: "auto" }, draggableId: item.id, index: index }, { children: function (provided, snapshot) {
                if (snapshot.isDragging) {
                    // @ts-ignore
                    provided.draggableProps.style.left = provided.draggableProps.style.offsetLeft;
                    // @ts-ignore
                    provided.draggableProps.style.top = provided.draggableProps.style.offsetTop;
                }
                return (_jsxs("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { children: [item.element, provided['placeholder']] })));
            } })));
    }
    return item.element;
}
export default Item;
